import React from 'react';
import { render } from '@testing-library/react';
import AppSection from './app_section';

describe('AppSection', () => {
    it('renders app name and view all link', () => {
        const app = { name: 'Slides', short_name: 'slides', link: '/slides', items: [] };
        const { getByText } = render(<AppSection app={app} />);
        expect(getByText('Slides')).toBeTruthy();
    });

    it('renders empty state when no items', () => {
        const app = { name: 'Slides', short_name: 'slides', link: '/slides', items: [] };
        const { getByText } = render(<AppSection app={app} />);
        expect(getByText('No slides yet')).toBeTruthy();
    });

    it('renders slides cards for slides app', () => {
        const app = {
            name: 'Slides', short_name: 'slides', link: '/slides',
            items: [{ id: 1, name: 'My Presentation', updated_at: '2026-04-14' }]
        };
        const { getByText } = render(<AppSection app={app} />);
        expect(getByText('My Presentation')).toBeTruthy();
    });

    it('renders billboard cards for billboard app', () => {
        const app = {
            name: 'Billboard', short_name: 'billboard', link: '/billboard',
            items: [{ id: 1, name: 'Main Playlist', thumbnail_url: null }]
        };
        const { getByText } = render(<AppSection app={app} />);
        expect(getByText('Main Playlist')).toBeTruthy();
    });

    it('renders billboard card with thumbnail', () => {
        const app = {
            name: 'Billboard', short_name: 'billboard', link: '/billboard',
            items: [{ id: 1, name: 'With Image', thumbnail_url: 'https://example.com/img.jpg' }]
        };
        const { container } = render(<AppSection app={app} />);
        const img = container.querySelector('img');
        expect(img.src).toBe('https://example.com/img.jpg');
    });
});
